import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr";

// Login Redux States
import {
  ADD_RATERS_INVITES,
  EDIT_RATERS_INVITES,
  VIEW_RATERS_INVITES,
  LIST_RATERS_INVITES,
  DELETE_RATERS_INVITES,
  ADD_RATERS_INVITES_TEXT,
  EDIT_RATERS_INVITES_TEXT,
  VIEW_RATERS_INVITES_TEXT,
  LIST_RATERS_INVITES_TEXT,
  DELETE_RATERS_INVITES_TEXT
} from "./actionTypes"
import { ratersInvitesSuccess, ratersInvitesError } from "./actions"

import {
  onAddRatersInvites,
  onEditRatersInvites,
  onViewRatersInvites,
  onListRatersInvites,
  onDeleteRatersInvites,
  onAddRatersInvitesText,
  onEditRatersInvitesText,
  onListRatersInvitesText,
  onViewRatersInvitesText,
  onDeleteRatersInvitesText
} from "helpers/backend_api_helper";

// add Invites
function* addRatersInvites({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddRatersInvites, data);
    yield put(ratersInvitesSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Invites
function* ratersEditInvites({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditRatersInvites, data, id);
    yield put(ratersInvitesSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// list Invites
function* listRatersInvites({ payload: { data, callback } }) {
  try {
    const response = yield call(onListRatersInvites, data);
    yield put(ratersInvitesSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// view Invites
function* viewRatersInvites({ payload: { data, history } }) {
  try {
    const response = yield call(onViewRatersInvites, data);
    yield put(ratersInvitesSuccess(response));

  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Invites
function* deleteRatersInvites({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteRatersInvites, data);
    yield put(ratersInvitesSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add Invites
function* addAspirationText({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddRatersInvitesText, data);
    yield put(ratersInvitesSuccess(response));
    callback && callback(response);
  } catch (error) {
    toastr.error(error?.response?.data?.message);
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Invites
function* ratersEditInvitesText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditRatersInvitesText, data, id);
    yield put(ratersInvitesSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// list Invites
function* listRatersInvitesText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListRatersInvitesText, data, id);
    yield put(ratersInvitesSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// view Invites
function* viewAspirationText({ payload: { data, history } }) {
  try {
    const response = yield call(onViewRatersInvitesText, data);
    yield put(ratersInvitesSuccess(response));

  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Invites
function* deleteAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteRatersInvitesText, data);
    yield put(ratersInvitesSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(ratersInvitesError(error?.response?.data?.message || "Server Error"));
  }
}



function* InvitesSaga() {
  yield takeEvery(ADD_RATERS_INVITES, addRatersInvites);
  yield takeEvery(EDIT_RATERS_INVITES, ratersEditInvites);
  yield takeEvery(LIST_RATERS_INVITES, listRatersInvites);
  yield takeEvery(VIEW_RATERS_INVITES, viewRatersInvites);
  yield takeEvery(DELETE_RATERS_INVITES, deleteRatersInvites);

  // text
  yield takeEvery(ADD_RATERS_INVITES_TEXT, addAspirationText);
  yield takeEvery(EDIT_RATERS_INVITES_TEXT, ratersEditInvitesText);
  yield takeEvery(LIST_RATERS_INVITES_TEXT, listRatersInvitesText);
  yield takeEvery(VIEW_RATERS_INVITES_TEXT, viewAspirationText);
  yield takeEvery(DELETE_RATERS_INVITES_TEXT, deleteAspirationText);
}

export default InvitesSaga;

